import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import VenueForm from '../Form';
import { fetchVenue, updateVenue } from '@resources/Venue/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';

const Update = (props) => {
	const { module, fetchVenue, venue, updateVenue, visible, onCancel } = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchVenue(visible);
		};
		visible && fetchData();
	}, [fetchVenue, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateVenue(venue._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.venue.update',
							defaultMessage:
								'An existing Venue entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[venue]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.venue',
					defaultMessage: 'Update Venue',
				})}
			</Title>
			{!isEmpty(venue) && (
				<VenueForm
					data={venue}
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	venue,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		venue,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	fetchVenue,
	updateVenue,
})(Update);
